import boticarioConfig from './boticario';
import eudoraConfig from './eudora';
import vdiConfig from './vdi';

import type { Config } from 'core/domains/config';

let config: Config | undefined;

const detectStore = () => {
  if (config) return config;

  const stores = [
    {
      config: eudoraConfig,
      host: 'eudora.com.br',
      name: 'eudora',
    },
    {
      config: boticarioConfig,
      host: 'boticario.com.br',
      name: 'boticario',
    },
    {
      config: vdiConfig,
      host: 'venda-direta.grupoboticario.digital',
      name: 'vdi',
    },
  ];
  const DEFAULT_STORE = 'eudora';

  if (['development', 'test'].includes(process.env.NODE_ENV as string)) {
    const storeName = process.env.REACT_APP_BRAND || DEFAULT_STORE;
    config = stores.find((store) => store.name === storeName)?.config;
    return config as Config;
  }

  config = stores.find(function (store) {
    const re = new RegExp(store.host);

    return re.test(window.location.host);
  })?.config;

  return config as Config;
};

export default detectStore();
